/**
 * Helpers de dates. Tout est calculé en heure LOCALE : une séance du dimanche
 * 23h doit compter pour la semaine que l'utilisateur a vécue, pas pour celle
 * d'UTC. Le jour de départ de semaine est le lundi (norme ISO, et attendu en FR).
 */

export const DAY_MS = 86_400_000

export function startOfDay(date: Date): Date {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

/** Lundi 00:00 de la semaine contenant `date`. */
export function startOfWeek(date: Date): Date {
  const d = startOfDay(date)
  const isoDay = d.getDay() === 0 ? 7 : d.getDay() // dimanche -> 7
  d.setDate(d.getDate() - (isoDay - 1))
  return d
}

export function addWeeks(date: Date, weeks: number): Date {
  const d = new Date(date)
  d.setDate(d.getDate() + weeks * 7)
  return d
}

export function addDays(date: Date, days: number): Date {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

/** Clé ISO stable pour identifier une semaine, ex. "2026-W40". */
export function isoWeekKey(date: Date): string {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  )
  const isoDay = d.getUTCDay() === 0 ? 7 : d.getUTCDay()
  // On se place sur le jeudi de la semaine : il détermine l'année ISO.
  d.setUTCDate(d.getUTCDate() + 4 - isoDay)
  const yearStart = Date.UTC(d.getUTCFullYear(), 0, 1)
  const week = Math.ceil(((d.getTime() - yearStart) / DAY_MS + 1) / 7)
  return `${d.getUTCFullYear()}-W${String(week).padStart(2, '0')}`
}

/** "2026-09" — utilisé pour attribuer le joker mensuel de streak. */
export function monthKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}

/** Écart en jours fractionnaires (peut être négatif). */
export function daysBetween(from: Date, to: Date): number {
  return (to.getTime() - from.getTime()) / DAY_MS
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value))
}
